import { useMemo } from 'react';

import { useExternalFolderDetailTableQuery } from 'generated/graphql';



export type IFolderRow = {
  id: string;
  fileName: string;
  formattedFileSize: string;
  url: string;
};

export interface IData {
  rows: IFolderRow[];
}

export function useQuery(folderId: string) {
  const tuple = useExternalFolderDetailTableQuery({
    skip: !folderId,
    variables: {
      folderId
    }
  });

  return useMemo(
    () => {
      const data: IData = {
        rows: tuple.data?.folder?.documents.map((d): IFolderRow => ({
          id: d.id,
          fileName: d.title,
          formattedFileSize: d.apiFile.formattedFileSize,
          url: d.apiFile.url
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
